import cn from "classnames";
import { useTranslation } from "react-i18next";

import { BaseMessage } from "../../aiConversations.types";
import {
  isUnknownOriginMessage,
  outgoingSenderLabel
} from "../../helpers/correction";

import styles from "./BubbleMeta.module.scss";

interface Props {
  message: BaseMessage;
  onCorrect?: () => void;
}

// The line under a bubble: who sent an outgoing message (AI, automatic
// message or a team member), the time, and "Correct this reply" when allowed.
// Unknown-origin labels carry data-unknown-origin, read by the one tooltip
// ChatView renders for all of them.
const BubbleMeta = ({ message, onCorrect }: Props) => {
  const { t } = useTranslation();
  const label = outgoingSenderLabel(message);
  const unknownOrigin = isUnknownOriginMessage(message);

  return (
    <div className={styles.meta}>
      {label ? (
        <span
          className={cn(styles.label, {
            [styles.labelAi]: label === "ai",
            [styles.labelHuman]: label === "human",
            [styles.labelUnknown]: unknownOrigin
          })}
          data-unknown-origin={unknownOrigin ? "true" : undefined}
        >
          {t(`aiTurn.label.${label}`)}
        </span>
      ) : null}
      <span className={styles.time}>{message.time}</span>
      {onCorrect ? (
        <button type="button" className={styles.correct} onClick={onCorrect}>
          {t("aiTurn.correct")}
        </button>
      ) : null}
    </div>
  );
};

export default BubbleMeta;
